import translations from 'client/internationalization/translation-map.json';
import { TFunction } from 'i18next';
import { isArray } from 'es-toolkit/compat';
import { Text } from '@oliasoft-open-source/react-ui-library';

const translateTooltip = (tooltip: string, t?: TFunction) => ((t && Object.keys(translations).includes(tooltip)) ? t(tooltip) : tooltip);
export const formatTableTooltip = (tooltip: string | string[], t?:TFunction) => (isArray(tooltip) ? tooltip.map(line => (<Text key={line}>{translateTooltip(line, t)}</Text>)) : translateTooltip(tooltip, t));